import { nhanTrangThaiPartner } from "../../../../models/Partner";
import React, { useEffect, useRef, useState } from "react";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import {
	PartnerInnerContent,
	PartnerInnerName,
	PartnerInnerNameWWrap,
	UserFormServiceButtonClose,
} from "../../MyBooking/styled/DesStyled";
import usePartnerDetail from "../hook/useGetUserDetail";
import Partner from "../../../../models/Partner";
import { getPartnerAvailableSummary } from "../../../../services/PartnerService";
import moment from "moment";

export default function DialogInfoPartnerAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	partnerId: string;
	reload: () => void;
	/**
	 * VÒNG 2 (CGO ↔ COO): sửa ảnh · đánh giá · các bước · quãng đi bộ là việc BIÊN
	 * TẬP NỘI DUNG cho trang khách, không phải việc quản trị station — nhưng trước
	 * nay chúng chiếm 4 dòng trong menu quản trị của MỌI hàng. Nay gom vào đây: xem
	 * và sửa cùng một chỗ.
	 * VÒNG 4: thêm cả Edit, để xem xong sửa được ngay, không phải đóng ra mở lại.
	 */
	moEdit?: () => void;
	moImages?: () => void;
	moReviews?: () => void;
	moSteps?: () => void;
	moWalking?: () => void;
}) {
	const { userDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Station detail"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Close
					</UserFormServiceButtonClose>
				</>
			}>
			<ThanhHanhDong
				moEdit={props.moEdit}
				moImages={props.moImages}
				moReviews={props.moReviews}
				moSteps={props.moSteps}
				moWalking={props.moWalking}
				dong={() => props.setOpenDialog(false)}
			/>
			<InputPartnerAdmin userDetail={userDetail} />
		</DialogWrapMedium>
	);
}

/**
 * NỘI DUNG hộp "Station detail" — dựng lại 28/08/2026 theo yêu cầu của Quân:
 * "phải có mục chi tiết để xem thông tin".
 *
 * Bản cũ có 15 dòng, nhãn TIẾNG VIỆT lẫn trong app tiếng Anh ("Tên", "Ngày tạo",
 * "lat", "Phí bảo hiểm"), thiếu hẳn những thứ hay phải tra nhất: station này thuộc
 * chuỗi nào, số dư công nợ bao nhiêu, hotline là gì, có bị khoá rút tiền không.
 *
 * Nguyên tắc chọn trường: chỉ hiện thứ **đọc để ra quyết định**. Những ô 0/302
 * station đang dùng (FAQ, instructions, meet title, map image, rate limits — đo trên
 * production 28/08) KHÔNG đưa vào, vì mỗi dòng trống là một dòng phải lướt qua.
 */

const oNhan: React.CSSProperties = {
	fontSize: "11px",
	fontWeight: 600,
	letterSpacing: "0.4px",
	textTransform: "uppercase",
	color: "#90a4ae",
	marginBottom: "2px",
};
const oGiaTri: React.CSSProperties = { fontSize: "13.5px", color: "#263238", wordBreak: "break-word" };
const oKhoi: React.CSSProperties = {
	border: "1px solid #eceff1",
	borderRadius: "10px",
	padding: "12px 14px",
	marginBottom: "10px",
	background: "#fff",
};
const oTieuDeKhoi: React.CSSProperties = {
	fontSize: "11px",
	fontWeight: 700,
	letterSpacing: "0.7px",
	textTransform: "uppercase",
	color: "#607d8b",
	marginBottom: "9px",
};
const oLuoi: React.CSSProperties = {
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
	gap: "11px 18px",
};

function O(props: { nhan: string; children?: React.ReactNode }) {
	return (
		<div>
			<div style={oNhan}>{props.nhan}</div>
			<div style={oGiaTri}>{props.children ?? <span style={{ color: "#b0bec5" }}>—</span>}</div>
		</div>
	);
}

function Khoi(props: { ten: string; children: React.ReactNode }) {
	return (
		<div style={oKhoi}>
			<div style={oTieuDeKhoi}>{props.ten}</div>
			<div style={oLuoi}>{props.children}</div>
		</div>
	);
}

/** Số tiền — để trống thì trả về undefined để ô hiện dấu gạch, không hiện "0". */
function tien(v?: number | null, dv = "USD"): React.ReactNode | undefined {
	if (v === null || v === undefined || Number.isNaN(Number(v))) return undefined;
	return `${Number(v).toLocaleString("en-US", { maximumFractionDigits: 2 })} ${dv}`;
}

/** Thanh hành động đầu hộp chi tiết — gom việc hay làm ngay sau khi xem. */
function ThanhHanhDong(props: {
	moEdit?: () => void;
	moImages?: () => void;
	moReviews?: () => void;
	moSteps?: () => void;
	moWalking?: () => void;
	dong: () => void;
}) {
	const nut: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		gap: 5,
		padding: "6px 12px",
		borderRadius: 8,
		border: "1px solid #dfe4e8",
		background: "#fff",
		color: "#37474f",
		fontSize: 12.5,
		fontWeight: 600,
		cursor: "pointer",
	};
	const muc: { chu: string; icon: string; ham?: () => void }[] = [
		{ chu: "Edit", icon: "✏️", ham: props.moEdit },
		{ chu: "Images", icon: "📸", ham: props.moImages },
		{ chu: "Reviews", icon: "⭐", ham: props.moReviews },
		{ chu: "Process steps", icon: "📝", ham: props.moSteps },
		{ chu: "Walking distance", icon: "🚶", ham: props.moWalking },
	].filter((m) => Boolean(m.ham));
	if (!muc.length) return null;
	return (
		<div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
			{muc.map((m) => (
				<button
					key={m.chu}
					type="button"
					style={nut}
					onClick={() => {
						// Đóng hộp xem trước rồi mới mở hộp sửa: hai hộp chồng nhau thì
						// bấm Esc không biết đóng cái nào.
						props.dong();
						m.ham?.();
					}}>
					<span>{m.icon}</span>
					{m.chu}
				</button>
			))}
		</div>
	);
}

export function InputPartnerAdmin(props: { userDetail?: Partner }) {
	const p: any = props.userDetail || {};
	// Một bảng nhãn duy nhất cho cả app — trước 25/08 màn này tự ghi "Đã kích hoạt"
	// trong khi bảng ghi "Actived" và DB lưu "actived": ba cách gọi một thứ.
	const statusLabel = nhanTrangThaiPartner(p);

	const store = p.store || null;
	const laChuChuoi = Number(p.partnerRoleId) === 2 || (store && Number(store.storeOwnerPartnerId) === Number(p.id));
	// 08/10: có Store nhưng `chainModeEnabled = false` ⇒ ghi rõ "· OFF" (Admin chưa bật / đã tắt).
	const cheDoTat = store && store.chainModeEnabled === false;
	const loai = laChuChuoi
		? cheDoTat ? "Chain owner · OFF" : "Chain owner"
		: p.storeId || store ? (cheDoTat ? "In chain · OFF" : "In chain") : "Single";
	const gio = p.workTime?.[0]?.hour;
	// 20/10/2026 — Số dư lấy từ SỔ CÁI (cùng nguồn trạm thấy ở Debt Center), kèm đúng tiền tệ.
	// Bản cũ hiện `availableDeductionAmount` + nhãn `localCurrencyCode || "USD"`: trường đó là
	// khoản điều chỉnh treo của hệ cũ (bỏ từ khi chuyển sổ 02/10) còn cột tiền tệ thì trống ở mọi
	// trạm ⇒ Anise hiện "-200,000 USD · WhaleLO owes station" trong khi số dư thật 5,268,600 VND.
	const [soDuSoCai, setSoDuSoCai] = useState<{ soDu: number; rutDuoc?: number; tienTe: string } | null>(null);
	const [loiSoDu, setLoiSoDu] = useState(false);
	useEffect(() => {
		let conMo = true;
		setSoDuSoCai(null);
		setLoiSoDu(false);
		if (!p.id) return;
		getPartnerAvailableSummary(String(p.id))
			.then((res) => {
				const s = res?.summary;
				if (!conMo || !s || !s.currencyCode || !Number.isFinite(Number(s.availableAmount))) return;
				setSoDuSoCai({
					soDu: Number(s.availableAmount),
					rutDuoc: Number.isFinite(Number(s.withdrawableAmount)) ? Number(s.withdrawableAmount) : undefined,
					tienTe: String(s.currencyCode),
				});
			})
			.catch(() => {
				// Không có quyền xem tài chính / API lỗi ⇒ để dấu gạch, KHÔNG đoán số.
				if (conMo) setLoiSoDu(true);
			});
		return () => {
			conMo = false;
		};
	}, [p.id]);
	const dsAnh = Array.isArray(p.images) ? p.images.length : 0;
	const dsFeature = Array.isArray(p.features) ? p.features.length : 0;
	const hotline = Array.isArray(p.hotlineNumber) ? p.hotlineNumber.filter(Boolean).join(" · ") : p.hotlineNumber;
	const laLink = /^https?:\/\//i.test(String(p.address || "").trim());

	return (
		<div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
			<Khoi ten="Identity">
				<O nhan="Station ID">#{p.id}</O>
				<O nhan="Status">{statusLabel}</O>
				<O nhan="Account type">{loai}</O>
				<O nhan="Name">{p.name}</O>
				<O nhan="Display name">{p.displayName}</O>
				{loai !== "Single" ? <O nhan="Chain owner">{store?.storeOwnerUser?.email}</O> : null}
				<O nhan="Created">{p.createdAt ? moment(p.createdAt).format("HH:mm DD/MM/YYYY") : undefined}</O>
			</Khoi>

			<Khoi ten="Contact">
				<O nhan="Account email">{p.user?.email}</O>
				<O nhan="Hotline">{hotline}</O>
				<O nhan="Representative">{p.representativeName}</O>
				<O nhan="Representative email">{p.representativeEmail}</O>
			</Khoi>

			<Khoi ten="Location">
				<O nhan="Google Maps">
					{laLink ? (
						<a
							href={p.address}
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: "#2e7d32", fontWeight: 600, textDecoration: "none" }}>
							📍 Open map
						</a>
					) : (
						p.address
					)}
				</O>
				<O nhan="Address text">{p.addressText}</O>
				<O nhan="Display address">{p.displayAddress}</O>
				<O nhan="Destination">{p.destination?.fullName || p.destination?.name}</O>
				{/* Toạ độ là điều kiện để station được lên bán — thiếu là nằm ở Approved mãi. */}
				<O nhan="Coordinates">{p.lat && p.long ? `${p.lat}, ${p.long}` : undefined}</O>
				<O nhan="Opening hours">{gio?.from && gio?.to ? `${gio.from} – ${gio.to}` : undefined}</O>
			</Khoi>

			<Khoi ten="Commercial">
				<O nhan="Service fee">{tien(p.fee)}</O>
				<O nhan="Insurance fee">{tien(p.insuranceFee)}</O>
				<O nhan="Station commission">{tien(p.stationCom)}</O>
				<O nhan="Publish rate">{tien(p.pubRate)}</O>
				<O nhan="Station balance">
					{soDuSoCai ? (
						<span style={{ color: soDuSoCai.soDu < 0 ? "#c62828" : "#2e7d32", fontWeight: 600 }}>
							{tien(soDuSoCai.soDu, soDuSoCai.tienTe)}
							{soDuSoCai.rutDuoc !== undefined ? (
								<span style={{ color: "#90a4ae", fontWeight: 400, fontSize: "11px" }}>
									{` · withdrawable ${tien(soDuSoCai.rutDuoc, soDuSoCai.tienTe)}`}
								</span>
							) : null}
						</span>
					) : loiSoDu ? (
						<span style={{ color: "#90a4ae" }}>Not available — open Financial</span>
					) : undefined}
				</O>
				<O nhan="Payout">
					{p.payoutLocked ? (
						<span style={{ color: "#b71c1c", fontWeight: 600 }}>
							Locked{p.payoutLockReason ? ` · ${p.payoutLockReason}` : ""}
						</span>
					) : (
						"Open"
					)}
				</O>
			</Khoi>

			<Khoi ten="Customer page">
				<O nhan="Photos">{dsAnh > 0 ? `${dsAnh} photo(s)` : undefined}</O>
				<O nhan="Process steps">{dsFeature > 0 ? `${dsFeature} step(s)` : undefined}</O>
				<O nhan="Rating">{p.rateReview ? `${p.rateReview} / 5 · ${p.reviewCount || 0} review(s)` : undefined}</O>
				<O nhan="Walking distance">{p.walkingDistance}</O>
			</Khoi>

			{p.note ? (
				<Khoi ten="Internal note">
					<O nhan="Note">{p.note}</O>
				</Khoi>
			) : null}
		</div>
	);
}
